(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brunching-sticky-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setStickyTop() {
      var top = 0;
      var group = document.getElementById('header-group');
      if (group) {
        Array.prototype.forEach.call(group.children, function (el) {
          var position = getComputedStyle(el).position;
          if (position === 'sticky' || position === 'fixed') {
            top += el.getBoundingClientRect().height;
          }
        });
      }
      document.querySelectorAll('.bsg').forEach(function (el) {
        el.style.setProperty('--bsg-top', top + 16 + 'px');
      });
    }

    function startVideos() {
      document.querySelectorAll('.bsg video').forEach(function (video) {
        if (video.dataset.bsgReady) return;
        video.dataset.bsgReady = '1';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.addEventListener('ended', function () {
          video.currentTime = 0;
          var again = video.play();
          if (again && again.catch) again.catch(function () {});
        });
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      });
    }

    function init() {
      setStickyTop();
      startVideos();
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('.bsg input[data-bq-colour]')) return;
      var card = input.closest('.bsg-card');
      var image = card && card.querySelector('.bsg-card__img--main');
      if (image && input.dataset.image) {
        image.removeAttribute('srcset');
        image.src = input.dataset.image;
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('load', init);
    window.addEventListener('resize', setStickyTop);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
